import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=5c461063&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=ts"
export * from "./CookiesPolicy.vue?vue&type=script&lang=ts"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=5c461063&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c461063",
  null
  
)

export default component.exports